export default "__VITE_ASSET__CkBDjerQ__"